import { navItems } from './nav-items'

# Phone menu: a hamburger button fixed in the top-right corner, so it stays
# on screen as the page scrolls. It opens a panel from the right. The button is
# a dark translucent disc with a white ring so it stays readable on any photo
# or page content.
tag nav-drawer
	prop selected\string = ""
	isOpen = false
	moreOpen = false

	def open
		isOpen = true

	def close
		isOpen = false

	def go item
		imba.router.go(item.route)
		close!

	def onKey e
		if e.key === 'Escape' and isOpen
			close!
			imba.commit!

	def mount
		#onKey = onKey.bind(self)
		document.addEventListener('keydown', #onKey)

	def unmount
		document.removeEventListener('keydown', #onKey)

	def isActive item
		item.children ? item.children.some(do(c) c.route === selected) : item.route === selected

	<self.nav-drawer .open=isOpen>
		<button.burger @click=open aria-label="Open menu" aria-expanded=isOpen>
			<span.bar>
			<span.bar>
			<span.bar>
		<div.backdrop @click=close>
		<nav.panel aria-hidden=!isOpen>
			<div.panel-head>
				<span.panel-title> "Grace Lutheran"
				<button.close @click=close aria-label="Close menu">
					<i.fa.fa-times>
			for item in navItems
				if item.children
					<button.item .active=isActive(item) @click=(moreOpen = !moreOpen) aria-expanded=moreOpen>
						<i.fa-fw.fa-{item.icon} .fa=!item.brand .fab=item.brand>
						<span> item.label
						<i.fa.fa-chevron-down.caret .rotated=moreOpen>
					if moreOpen
						<div.sub>
							for child in item.children
								<nav-drawer-link item=child active=(child.route === selected) @navigate=go(child)>
				else
					<nav-drawer-link item=item active=(item.route === selected) @navigate=go(item)>

tag nav-drawer-link
	prop item
	prop active = false

	<self>
		if item.route
			<a.item .active=active @click=emit('navigate')>
				<i.fa-fw.fa-{item.icon} .fa=!item.brand .fab=item.brand>
				<span> item.label
		else
			<a.item href=item.url target="_blank" rel="noopener noreferrer">
				<i.fa-fw.fa-{item.icon} .fa=!item.brand .fab=item.brand>
				<span> item.label
				<i.fa.fa-external-link-alt.ext>

css .nav-drawer
	d@md:none
	.burger
		# fixed so it follows the page; below the backdrop and panel (1050+)
		pos:fixed top:1em right:1em zi:900
		w:56px h:56px rd:full
		d:flex fld:column jc:center ai:center gap:6px
		bgc:rgba(0,0,0,.6) @hover:rgba(0,0,0,.8)
		bd:2px solid white/85%
		box-shadow:0 2px 10px rgba(0,0,0,.45)
		backdrop-filter:blur(6px)
		cursor:pointer
	.bar
		d:block w:26px h:3px rd:2px bgc:white
	.backdrop
		pos:fixed inset:0 zi:1050
		bgc:rgba(0,0,0,.45)
		opacity:0 pe:none
		transition:opacity .25s ease
	.panel
		pos:fixed top:0 right:0 bottom:0 zi:1080
		w:320px maw:85vw
		bgc:cooler9 c:white
		pb:2em
		ofy:auto
		box-shadow:-10px 0 30px rgba(0,0,0,.35)
		transform:translateX(100%)
		transition:transform .3s ease
	.panel-head
		d:flex ai:center jc:space-between
		px:1.5em py:1em mb:.5em
		bdb:1px solid white/15%
	.panel-title
		fs:.85em tt:uppercase ls:.12em c:amber4 fw:700
	.close
		w:44px h:44px rd:full
		bgc:white/10% @hover:white/20% bd:none
		c:white fs:1.3em cursor:pointer
	.item
		d:flex ai:center gap:.9em w:100%
		px:1.5em py:.8em
		fs:1.2em fw:500 c:white td:none cursor:pointer ta:left
		bgc:transparent @hover:white/10% bd:none
		bdl:4px solid transparent
		ff:inherit
		&.active bdl:4px solid amber4 bgc:white/5%
		.ext fs:.7em c:white/50% ml:auto
		.caret fs:.75em ml:auto transition:transform .2s ease
		.caret.rotated transform:rotate(180deg)
	.sub
		bgc:black/20%
		.item pl:2.75em fs:1.1em

	&.open
		.backdrop opacity:1 pe:auto
		.panel transform:none
